var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"physical-home-container"},[_c('SearchHead',{attrs:{"type":"physical","placeholder":"输入关键字或商品链接、口令"}}),_c('Banner'),_c('HomeDocument'),_c('HomeHot'),_c('HomeDowntick')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }